import { createContext } from 'react';

import type { CmsRendering } from '@eneco/cms-adapter';

/**
 * Per-rendering context. Set by `Placeholder` for each child it renders, so
 * `useContent<T>()` can pluck the correct content slice without prop drilling.
 *
 * Stored on `globalThis` to survive double-evaluation of this module under
 * the SSR/Vite split that bit us in `libs/sitecore/common`.
 */
const KEY = '__eneco_cms_rendering_context__' as const;
type Ctx = ReturnType<typeof createContext<CmsRendering | undefined>>;

const store = globalThis as unknown as Record<string, Ctx>;

export const RenderingContext: Ctx =
  store[KEY] ?? createContext<CmsRendering | undefined>(undefined);

store[KEY] = RenderingContext;
